<div class="card">
	<div class="card__content">
		<h2 class="card__title" [ngClass]="{'card__title--course': course}">{{data.title || data.name}}</h2>
		<div class="card__circle" *ngIf="course"
			 [style.background]="data.circle_color"
			 [style.color]="data.circle_text_color"
			 [style.border]="'2px solid ' + data.circle_edge_color">
			{{data.circle_text}}
		</div>
		<div class="card__icon" *ngIf="!course">
			<img src="assets/images/education/icons/{{data.photo}}" alt="">
		</div>
		<h3 class="card__name-course" [class.card__name-course--size24]="course">{{data.nameCourse || data.description}}</h3>
		<div class="card__course" *ngIf="data.info">
			<div class="card__course-info" *ngFor="let item of data.info">{{ item }}</div>
		</div>
	</div>
	<a [routerLink]="[data.link]" class="card__button" *ngIf="!course">смотреть всё</a>
	<a (click)="openModal('about-course', data.id, data)" class="card__button" *ngIf="course">смотреть</a>
</div>

<app-about-course [idDirection]="idDirection"></app-about-course>
